import React from 'react'
import IconBreadcrumbChevron from '../icons/IconBreadcrumbChevron/IconBreadcrumbChevron'
import { getParentPageURLSegment } from '@/domain/blogPosts/getParentPageURLSegment'
import { getReturnToBlogHomeLink } from '@/domain/blogPosts/getReturnToBlogHomeLink'

interface BlogBreadCrumbsProps {
  isNews: boolean
  isVoices: boolean
  isCircleOfChairs: boolean
  isPodcast: boolean
  blogTitle: string
}

const BreadcrumbLink = ({ isNews, isVoices, isCircleOfChairs, isPodcast }) => {
  const title = getReturnToBlogHomeLink({
    isNews,
    isVoices,
    isCircleOfChairs,
    isPodcast
  })
  const slug = getParentPageURLSegment(
    isNews,
    isVoices,
    isCircleOfChairs,
    isPodcast
  )

  return (
    <a
      className="rounded-md px-1 py-0.5 text-xs font-medium text-gray-900 hover:bg-white/70 active:bg-white/90"
      href={`/${slug}/`}
    >
      {title}
    </a>
  )
}

export const BlogBreadCrumbs = ({
  isNews,
  isVoices,
  isCircleOfChairs,
  isPodcast,
  blogTitle
}) => {
  const title = blogTitle?.slice(0, 30).trim().concat('...')
  return (
    <div className="hide-scroll -mx-5 flex items-center overflow-x-auto whitespace-nowrap px-5 text-xs font-medium md:mx-0 md:px-0">
      <BreadcrumbLink
        isNews={isNews}
        isVoices={isVoices}
        isCircleOfChairs={isCircleOfChairs}
        isPodcast={isPodcast}
      />{' '}
      <IconBreadcrumbChevron
        className="mx-0.5 shrink-0 text-gray-1000"
        strokeWidth="1"
      />
      <span className="px-1 py-0.5 text-xs font-semibold text-gray-1100">
        {title}
      </span>
    </div>
  )
}
